/* eslint import/no-extraneous-dependencies: 0, no-shadow: 0, react/no-danger: 0, react/no-array-index-key: 0  */
import React, { useRef, useEffect } from 'react';
import Observer from 'react-intersection-observer';
import content from '../../content';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

import { GAfireEvent } from '../Tracking';
import { fireTag } from '../../libs/analytics';

import leaves from "../../images/sustainability/programs-resources/leaves.png";
import bulb from "../../images/sustainability/programs-resources/bulb.png";
import twoPeople from "../../images/sustainability/programs-resources/two-people.png";
import target from "../../images/sustainability/programs-resources/target.png";
import sprout from "../../images/sustainability/programs-resources/sprout.png";
import globe from "../../images/sustainability/programs-resources/globe.png";
import globeMobile from "../../images/sustainability/programs-resources/globe-mobile.png";
import globeDesktop from "../../images/sustainability/programs-resources/globe-desktop.png";

// const icons = [leaves, target, bulb, sprout, twoPeople, globe];
const iconsResponsive = {
	mobile: [leaves, target, bulb, globeMobile],
	desktop: [leaves, target, bulb, globeDesktop]
};


const icons = (window.innerWidth < 768) ? iconsResponsive.mobile : iconsResponsive.desktop;

const ProgramsResources = (props) => {
	const copy = content.sustainability["programs-resources"];
	const containerRef = useRef(null)

	let scrollProgramResources = false;

	useEffect(() => {
		window.addEventListener('scroll',()=>{
			if(window.location.href.includes('/sustainability/') && !scrollProgramResources && document.querySelector('#programs-resources').getBoundingClientRect().top <= document.querySelector('nav').getBoundingClientRect().height){
				scrollProgramResources = true;
				fireTag('S5');
			}
		});
	},[])

	function decodeHtmlEntities(str) {
		const textarea = document.createElement('textarea');
		textarea.innerHTML = str;
		return textarea.textContent;
	}

	return (
		<section className="sustainability__programs-resources" id="programs-resources" ref={containerRef}>
			<Observer
				tag='h2'
				tabIndex="-1"
				triggerOnce
				threshold={0.50}
				onChange={inView => {
					if (inView) {
						//GAfireEvent('isf_S4');
						//fireTag('S5');
					}
				}}
				dangerouslySetInnerHTML={{__html: copy.headline}}
			/>

			<div className="tile-container">
				{
					content.sustainability["programs-resources"].tiles.map((item, index) => (
						<a
							key={index}
							href={item.link}
							onClick={(e) => {
								//GAfireEvent(`isf_C20`, {label: `${item.headline.toLowerCase().replace(/(<([^>]+)>)/gi, "")}`});
								fireTag("C6",`${decodeHtmlEntities(item.headline.toLowerCase().replace(/(<([^>]+)>)/gi, ""))}` );
							}}
							className="tile"
							target="_blank"
							rel="noreferrer">
								<span className="tile-inner">
									<img src={icons[index]} alt={item.alt} />
									<span><h3 dangerouslySetInnerHTML={{__html: item.headline}}/><p>{item.subhead}</p></span>
								</span>
						</a>
					))
				}
			</div>

		</section>
	);
};

export default ProgramsResources;
